/** @format */

import React, { useEffect, useState } from "react";
import Select from "react-select";
import BackgroundImg from "../../layout/BackgroundImg";
import Logo from "../../layout/Logo";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategoryData,
  fetchChannelTypeData,
  fetchCityData,
  fetchGenreData,
  fetchLanguageData,
  fetchStateData,
  fetchDataYoutube,
} from "../../features/commonSlice/commonSlice";
import { parseNumber } from "../../utils/formatNumber";
import FormattedInput from "../common/FormattedInput";
import FormattedInputYouTube from "../common/FormattedInputYouTube";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import Breadcrumbs from "../../Breadcrumbs";
import { influencerRegisterData } from "../../features/influencerSlice/influencerSlice";

const InfluencerRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const decodeToken = useDecodedToken();
  const location = useLocation();

  const {
    categoryData,
    languageData,
    stateData,
    cityData,
    channelTypeData,
    genreData,
    youtubeData,
    status: commonStatus,
  } = useSelector((state) => state.influencer);

  const countryList = [
    { value: 1, label: "India" },
    { value: 2, label: "Others" },
  ];

  const [isChecked, setIsChecked] = useState(true);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [langList, setLangList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [youTubeData, setYouTubeData] = useState("");

  const [errors, setErrors] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [showToaster, setShowToaster] = useState(false);

  const [formData, setFormData] = useState({
    influencer_name: "",
    concern_name: "",
    mobile_number: "",
    email: "",
    pan_no: "",
    gst: "",
    channel_name: "",
    channel_type: [],
    state: "",
    city: "",
    language: "",
    imageUpload: "",

    below_channels: {
      youTube_status: "",
      youTube: {
        youTube_URL: "",
        genre: "",
        subscribers: "",
        language: "",
        average_Views: "",
        dedicated_Video_Cost: "",
        integrated_Video_Cost: "",
        conceptual_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      facebook_status: "",
      facebook: {
        facebook_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      instagram_status: "",
      instagram: {
        instagram_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      twitter_X_status: "",
      twitter_X: {
        twitter_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      linkedIn_status: "",
      linkedIn: {
        linkedIn_URL: "",
        genre: "",
        connections: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      whatsapp_status: "",
      whatsapp: {
        whatsapp_Channel_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      telegram_status: "",
      telegram: {
        telegram_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
      threads_status: "",
      threads: {
        threads_URL: "",
        genre: "",
        followers: "",
        video_Cost: "",
        audience_Age18to24: "",
        audience_Age25to34: "",
        audience_Age35to44: "",
        audience_Age44: "",
        audienceData: [
          {
            audienceCountry: "",
            audienceState: "",
            audienceCountryName: "",
            audienceStatePercentage: "",
          },
        ],
        audienceReachGenderMale: "",
        audienceReachGenderFemale: "",
        imageFile: "",
      },
    },
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    dispatch(fetchCategoryData());
    dispatch(fetchLanguageData());
    dispatch(fetchStateData());
    dispatch(fetchChannelTypeData());
    dispatch(fetchGenreData());
  }, []);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setCategoryList(categoryData);
      setLangList(languageData);
      setStateList(stateData);
      setChannelList(channelTypeData);
      setGenreList(genreData);
    }
  }, [
    commonStatus,
    categoryData,
    languageData,
    stateData,
    channelTypeData,
    genreData,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Determine if the field should be parsed as a number
    const shouldParseAsNumber = [
      "mobile_number",
      "followers",
      "subscribers",
      "dedicated_Video_Cost",
      "integrated_Video_Cost",
      "conceptual_Cost",
      "video_Cost",
      "connections",
    ].includes(name.split(".").pop());

    const parsedValue = shouldParseAsNumber ? parseNumber(value) : value;

    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      let field = newFormData;
      const keys = name.split(".");

      keys.slice(0, -1).forEach((key) => {
        if (!field[key]) {
          field[key] = {};
        }
        field = field[key];
      });

      field[keys[keys.length - 1]] = parsedValue;

      return newFormData;
    });
  };

  const handleImageUpload = (e, channelName) => {
    const file = e.target.files[0];

    if (!file) return;

    setFormData((prev) => ({
      ...prev,
      below_channels: {
        ...prev.below_channels,
        [channelName]: {
          ...prev.below_channels[channelName],
          imageFile: file,
        },
      },
    }));
  };

  // Example parseNumber function to prevent NaN
  const parseNumber = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? "" : parsed;
  };

  const handleSelectChange1 = (name, selectedOption) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      let field = newFormData;
      const keys = name.split(".");
      keys.slice(0, -1).forEach((key) => {
        if (!field[key]) {
          field[key] = {};
        }
        field = field[key];
      });
      field[keys[keys.length - 1]] = selectedOption;
      return newFormData;
    });
  };

  const handleBlur = () => {
    if (formData.below_channels.youTube.youTube_URL) {
      const payload = {
        channelName: formData.below_channels.youTube.youTube_URL,
      };

      dispatch(fetchDataYoutube(payload));
    }
  };

  const handleAddAudienceRow = (channelName) => {
    const audienceRows =
      formData?.below_channels?.[channelName]?.audienceData || [];

    if (audienceRows.length >= 5) {
      toast.error("Maximum 5 rows allowed");
      return;
    }

    const newRow = {
      audienceState: "",
      audienceCountryName: "",
      audienceStatePercentage: "",
    };

    setFormData((prev) => ({
      ...prev,
      below_channels: {
        ...prev.below_channels,
        [channelName]: {
          ...prev.below_channels[channelName],
          audienceData: [...audienceRows, newRow],
        },
      },
    }));
  };

  const handleRemoveAudienceRow = (channelName, index) => {
    const updatedRows = formData?.below_channels?.[
      channelName
    ]?.audienceData.filter((_, i) => i !== index);

    setFormData((prev) => ({
      ...prev,
      below_channels: {
        ...prev.below_channels,
        [channelName]: {
          ...prev.below_channels[channelName],
          audienceData: updatedRows,
        },
      },
    }));
  };

  const handleAudienceChange = (channelName, index, field, value) => {
    const audienceData =
      formData?.below_channels?.[channelName]?.audienceData || [];

    const updatedRows = [...audienceData];

    if (!updatedRows[index]) {
      updatedRows[index] = {};
    }

    updatedRows[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      below_channels: {
        ...prev.below_channels,
        [channelName]: {
          ...prev.below_channels[channelName],
          audienceData: updatedRows,
        },
      },
    }));
  };

  const createInfluencerFormData = () => {
  const formDataPayload = new FormData();
const CHANNELS = [
  "youTube",
  "facebook",
  "instagram",
  "twitter_X",
  "linkedIn",
  "whatsapp",
  "telegram",
  "threads",
];
  // Deep copy
  const payload = JSON.parse(JSON.stringify({
    influencer_status: isChecked ? "1" : "4",
    name: formData.influencer_name,
    concern_name: formData.concern_name,
    phone_no: formData.mobile_number,
    email: formData.email,
    pan_no: formData.pan_no,
    gst: formData.gst,
    channel_name: formData.channel_name,
    channel_type: formData.channel_type,
    state: formData.state,
    city: formData.city,
    language: formData.language,
    below_channels: {
      ...formData.below_channels,
    },
  }));

  // Remove imageFile from JSON
  CHANNELS.forEach((channel) => {
    if (payload?.below_channels?.[channel]) {
      delete payload.below_channels[channel].imageFile;
    }
  });

  // Append JSON Data
  formDataPayload.append("data", JSON.stringify(payload));

  // Append Files Separately
  CHANNELS.forEach((channel) => {
    const file = formData?.below_channels?.[channel]?.imageFile;

    if (file instanceof File) {
      formDataPayload.append(`file${channel}Image`, file);
    }
  });

  return formDataPayload;
};

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const influencerData = {
  //       influencer_status: isChecked ? "1" : "4",
  //       name: formData.influencer_name,
  //       concern_name: formData.concern_name,
  //       phone_no: formData.mobile_number,
  //       email: formData.email,
  //       pan_no: formData.pan_no,
  //       gst: formData.gst,
  //       channel_name: formData.channel_name,
  //       channel_type: formData.channel_type,
  //       state: formData.state,
  //       city: formData.city,
  //       language: formData.language,
  //       below_channels: {
  //         youTube_status: formData.below_channels.youTube_status ? "1" : "0",
  //         youTube: formData.below_channels.youTube,
  //         facebook_status: formData.below_channels.facebook_status ? "1" : "0",
  //         facebook: formData.below_channels.facebook,
  //         instagram_status: formData.below_channels.instagram_status
  //           ? "1"
  //           : "0",
  //         instagram: formData.below_channels.instagram,
  //         twitter_X_status: formData.below_channels.twitter_X_status
  //           ? "1"
  //           : "0",
  //         twitter_X: formData.below_channels.twitter_X,
  //         linkedIn_status: formData.below_channels.linkedIn_status ? "1" : "0",
  //         linkedIn: formData.below_channels.linkedIn,
  //         whatsapp_status: formData.below_channels.whatsapp_status ? "1" : "0",
  //         whatsapp: formData.below_channels.whatsapp,
  //         telegram_status: formData.below_channels.telegram_status ? "1" : "0",
  //         telegram: formData.below_channels.telegram,
  //         threads_status: formData.below_channels.threads_status ? "1" : "0",
  //         threads: formData.below_channels.threads,
  //       },
  //     };

  //     console.log(
  //       " influencerDatainfluencerDatainfluencerDatainfluencerData ==>",
  //       influencerData,
  //     );

  //     dispatch(influencerRegisterData(influencerData))
  //       .unwrap()
  //       .then((result) => {
  //         if (result.status) {
  //           setShowToaster(true);
  //           toast.success(result.message || "Registered Successfully");
  //           setFormData({
  //             influencer_name: "",
  //             concern_name: "",
  //             mobile_number: "",
  //             email: "",
  //             pan_no: "",
  //             gst: "",
  //             channel_name: "",
  //             channel_type: [],
  //             state: "",
  //             city: "",
  //             language: "",
  //             below_channels: {
  //               youTube_status: "",
  //               youTube: {
  //                 youTube_URL: "",
  //                 genre: "",
  //                 subscribers: "",
  //                 language: "",
  //                 average_Views: "",
  //                 dedicated_Video_Cost: "",
  //                 integrated_Video_Cost: "",
  //                 conceptual_Cost: "",
  //               },
  //               facebook_status: "",
  //               facebook: {
  //                 facebook_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //               instagram_status: "",
  //               instagram: {
  //                 instagram_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //               twitter_X_status: "",
  //               twitter_X: {
  //                 twitter_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //               linkedIn_status: "",
  //               linkedIn: {
  //                 linkedIn_URL: "",
  //                 genre: "",
  //                 connections: "",
  //                 video_Cost: "",
  //               },
  //               whatsapp_status: "",
  //               whatsapp: {
  //                 whatsapp_Channel_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //               telegram_status: "",
  //               telegram: {
  //                 telegram_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //               threads_status: "",
  //               threads: {
  //                 threads_URL: "",
  //                 genre: "",
  //                 followers: "",
  //                 video_Cost: "",
  //               },
  //             },
  //             password: "",
  //             confirmPassword: "",
  //           });
  //           navigate("/influencer-register");

  //           /* }
  //           }); */
  //         } else {
  //           setLoginError(result.message);
  //           setErrorData(
  //             Array.isArray(result?.form_err) ? result.form_err : [],
  //           );
  //         }
  //       })
  //       .catch((err) => {
  //         const message =
  //           typeof err?.message === "object"
  //             ? err.message?.message || err.message?.code
  //             : err.message;

  //         setLoginError(message || "Something went wrong");
  //         setErrorData(Array.isArray(err?.form_err) ? err.form_err : []);
  //         toast.error(message || "Error occurred");
  //       });
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //   }
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const finalFormData = createInfluencerFormData();

    // Debugging
    for (let pair of finalFormData.entries()) {
      console.log(pair[0], pair[1]);
    }

    dispatch(influencerRegisterData(finalFormData))
      .unwrap()
      .then((result) => {
        if (result.status) {
          toast.success(result.message || "Registered Successfully");
        } else {
          toast.error(result.message);
        }
      })
      .catch((err) => {
        toast.error(err.message || "Something went wrong");
      });

  } catch (error) {
    console.error(error);
  }
};

 
  const mapErrors = (errorData) => {
    const errorMap = {};

    if (!Array.isArray(errorData)) return errorMap; // ✅ FIX

    errorData.forEach((error) => {
      const path = error?.param?.split(".")?.join("_");

      let message = error?.msg;

      if (typeof message === "object") {
        message = message?.message || message?.code || "Invalid value";
      }

      if (path) {
        errorMap[path] = message;
      }
    });

    return errorMap;
  };

  const renderError = (err) => {
    if (!err) return null;

    if (typeof err === "string") return err;

    if (typeof err === "object") {
      return err.message || err.code || JSON.stringify(err);
    }

    return String(err);
  };

  useEffect(() => {
    if (!errorData) return;
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  const handleRadioChange = (event) => {
    setIsChecked(event.target.value === "active");
  };

  useEffect(() => {
    if (isChecked) {
      setFormData({
        influencer_name: "",
        concern_name: "",
        mobile_number: null,
        email: "",
        pan_no: null,
        gst: null,
        channel_name: "",
        channel_type: [],
        state: "",
        city: "",
        language: "",
        below_channels: {
          youTube_status: "",
          youTube: {
            youTube_URL: "",
            genre: "",
            subscribers: "",
            language: "",
            average_Views: "",
            dedicated_Video_Cost: "",
            integrated_Video_Cost: "",
            conceptual_Cost: "",
          },
          facebook_status: "",
          facebook: {
            facebook_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          instagram_status: "",
          instagram: {
            instagram_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          twitter_X_status: "",
          twitter_X: {
            twitter_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          linkedIn_status: "",
          linkedIn: {
            linkedIn_URL: "",
            genre: "",
            connections: "",
            video_Cost: "",
          },
          whatsapp_status: "",
          whatsapp: {
            whatsapp_Channel_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          telegram_status: "",
          telegram: {
            telegram_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          threads_status: "",
          threads: {
            threads_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
        },
        password: "",
        confirmPassword: "",
      });
    } else {
      setFormData({
        influencer_name: "",
        concern_name: "",
        mobile_number: null,
        email: "",
        pan_no: null,
        gst: null,
        channel_name: "",
        channel_type: [],
        state: "",
        city: "",
        language: "",
        below_channels: {
          youTube_status: "",
          youTube: {
            youTube_URL: "",
            genre: "",
            subscribers: "",
            language: "",
            average_Views: "",
            dedicated_Video_Cost: "",
            integrated_Video_Cost: "",
            conceptual_Cost: "",
          },
          facebook_status: "",
          facebook: {
            facebook_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          instagram_status: "",
          instagram: {
            instagram_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          twitter_X_status: "",
          twitter_X: {
            twitter_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          linkedIn_status: "",
          linkedIn: {
            linkedIn_URL: "",
            genre: "",
            connections: "",
            video_Cost: "",
          },
          whatsapp_status: "",
          whatsapp: {
            whatsapp_Channel_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          telegram_status: "",
          telegram: {
            telegram_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
          threads_status: "",
          threads: {
            threads_URL: "",
            genre: "",
            followers: "",
            video_Cost: "",
          },
        },
        password: "",
        confirmPassword: "",
      });
    }
  }, [isChecked]);

  // const handleChange = (event) => {
  //   const { name, checked } = event.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     below_channels: {
  //       ...prevState.below_channels,
  //       [name]: checked,
  //     },
  //   }));
  // };

  const handleChange = (event) => {
    const { name, checked } = event.target;

    setFormData((prevState) => ({
      ...prevState,

      below_channels: {
        ...prevState?.below_channels,

        [name]: checked,
      },
    }));
  };

  const handleSelectChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name === "state") {
      const stateId = value.value;
      const data = {
        state_id: stateId,
      };
      dispatch(fetchCityData(data));
    }
  };

  useEffect(() => {
    if (formData.state) {
      setCityList(cityData);
    }
  }, [cityData]);

  useEffect(() => {
    if (formData.below_channels.youTube?.youTube_URL !== "") {
      setFormData((prevData) => ({
        ...prevData,
        below_channels: {
          ...prevData.below_channels,
          youTube: {
            ...prevData.below_channels?.youTube,
            subscribers: youtubeData?.data?.subscriber,
            average_Views: youtubeData?.data?.AvgViews,
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        below_channels: {
          youTube: {
            subscribers: "",
            average_Views: "",
          },
        },
      }));
    }
  }, [youtubeData]);

  useEffect(() => {
    console.log(
      "formData formData formData formData ==>",
      formData.below_channels.youTube?.youTube_URL,
    );
  }, [formData]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Influencer Registration</h4>
            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body p-4">
              <div className="p-2 mt-4">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="radio"
                        id="active"
                        name="status"
                        value="active"
                        checked={isChecked}
                        onChange={handleRadioChange}
                      />
                      <label htmlFor="active"> Active</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="radio"
                        id="inactive"
                        name="status"
                        value="inactive"
                        checked={!isChecked}
                        onChange={handleRadioChange}
                      />
                      <label htmlFor="inactive"> Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <>
                  <div className="row">
                    <div className="mt-2">
                      <h5 className="text-primary">Personal Details</h5>
                    </div>
                    {isChecked && (
                      <>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="username" className="form-label">
                              Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="influencer_name"
                              placeholder="Please Enter Name"
                              value={formData.influencer_name}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="text-danger">
                              {errors.name && <p>{errors.name}</p>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="concernname" className="form-label">
                              Concern Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="concern_name"
                              placeholder="Please Enter Name"
                              value={formData.concern_name}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="text-danger">
                              {errors.concern_name && (
                                <> {errors.concern_name}</>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="phoneno" className="form-label">
                              Phone no <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobile_number"
                              placeholder="Please enter only numeric values"
                              value={formData.mobile_number}
                              onChange={handleInputChange}
                              required
                            />

                            <div className="text-danger">
                              {errors.phone_no && <p>{errors.phone_no}</p>}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {!isChecked && (
                      <div className="col-lg-4 mb-3">
                        <div>
                          <label for="video-field" className="form-label">
                            Channel Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="channel_name"
                            placeholder="Enter channel name"
                            value={formData.channel_name}
                            onChange={handleInputChange}
                            required
                          />
                          <div className="text-danger">
                            {errors.channel_name && (
                              <p>{errors.channel_name}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className={!isChecked ? "col-lg-4 mb-3" : "col-md-6"}>
                      <div className="mb-3">
                        <label for="useremail" className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="Enter email address"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.email && <p>{errors.email}</p>}
                        </div>
                      </div>
                    </div>
                    {isChecked && (
                      <>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="pan" className="form-label">
                              PAN no{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="pan_no"
                              placeholder="Enter PAN no"
                              value={formData.pan_no}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="text-danger">
                              {errors.pan_no && <p>{errors.pan_no}</p>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="gst" className="form-label">
                              GST{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="gst"
                              placeholder="Enter GST no"
                              value={formData.gst}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="text-danger">
                              {errors.gst && <p>{errors.gst}</p>}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      className={!isChecked ? "col-lg-4 mb-3" : "col-lg-6 mb-4"}
                    >
                      <div>
                        <label for="video-type-field" className="form-label">
                          Channel type{" "}
                        </label>
                        <Select
                          defaultValue="Select Categories"
                          isMulti
                          name="channel_type"
                          options={channelList?.data}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(selected) =>
                            handleSelectChange("channel_type", selected)
                          }
                          value={formData.channel_type}
                        />
                        <div className="text-danger">
                          {errors.channel_type && <p>{errors.channel_type}</p>}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label for="language">
                        Language<span className="text-danger">*</span>:
                      </label>
                      <Select
                        name="language"
                        options={langList?.data?.map((lang) => ({
                          value: lang.value,
                          label: lang.label,
                        }))}
                        classNamePrefix="select"
                        onChange={(selected) =>
                          handleSelectChange1("language", selected)
                        }
                        value={formData.language}
                      />
                      <div className="text-danger">
                        {errors.language && <p>{errors.language}</p>}
                      </div>
                    </div>
                    {isChecked && (
                      <>
                        <div className="mt-2">
                          <h5 className="text-primary">Location</h5>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="state" className="form-label">
                              State{" "}
                            </label>
                            <Select
                              name="state"
                              options={stateList?.data} // Adjust this mapping according to your state object structure
                              classNamePrefix="select"
                              onChange={(selected) =>
                                handleSelectChange("state", selected)
                              }
                              value={formData.state}
                            />
                            <div className="invalid-feedback">
                              Please select state
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="city" className="form-label">
                              City{" "}
                            </label>
                            <Select
                              name="city"
                              options={cityList?.data} // Adjust this mapping according to your state object structure
                              classNamePrefix="select"
                              onChange={(selected) =>
                                handleSelectChange("city", selected)
                              }
                              value={formData.city}
                            />
                            <div className="text-danger">
                              {errors.city && <p>{errors.city}</p>}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </>
                <hr />

                <div className="row mt-2 g-3">
                  <label>Select Below Channels</label>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="youTube_status"
                      checked={formData.below_channels.youTube_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="youtubeCheckbox">
                      {" "}
                      YouTube
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="facebook_status"
                      checked={formData.below_channels.facebook_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="facebookCheckbox">
                      {" "}
                      Facebook
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="instagram_status"
                      checked={formData.below_channels.instagram_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="instagramCheckbox">
                      {" "}
                      Instagram
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="twitter_X_status"
                      checked={formData.below_channels.twitter_X_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="twitterCheckbox">
                      {" "}
                      Twitter (X)
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="linkedIn_status"
                      checked={formData.below_channels.linkedIn_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="linkedinCheckbox">
                      {" "}
                      LinkedIn
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="whatsapp_status"
                      checked={formData.below_channels.whatsapp_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="whatsappCheckbox">
                      {" "}
                      Whatsapp
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="telegram_status"
                      checked={formData.below_channels.telegram_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="telegramCheckbox">
                      {" "}
                      Telegram
                    </label>
                  </div>
                  <div className="form-check col-lg-3 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="threads_status"
                      checked={formData.below_channels.threads_status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" for="threadsCheckbox">
                      {" "}
                      Threads
                    </label>
                  </div>

                  <div className="text-danger">
                    {errors.below_channels && <p>{errors.below_channels}</p>}
                  </div>
                </div>
                {formData.below_channels.youTube_status && (
                  <div id="youtubeInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Youtube</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="youtubeUrl">
                          Youtube URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.youTube.youTube_URL"
                          placeholder="Enter youTube URL"
                          value={formData.below_channels.youTube.youTube_URL}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          required
                        />

                        {/* <input type="text" className="form-control" name="yturl" id="youtubeUrl" value="" oninput="checkYoutube();" /> */}
                        <div className="text-danger">
                          {errors.below_channels_youTube_youTube_URL && (
                            <p>{errors.below_channels_youTube_youTube_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="ygenere">
                          Genre<span className="text-danger">*</span>:
                        </label>
                        <Select
                          name="below_channels.youTube.youTube_URL"
                          options={genreList?.data?.map((genre) => ({
                            value: genre.value,
                            label: genre.label,
                          }))}
                          classNamePrefix="select"
                          onChange={(selected) =>
                            handleSelectChange1(
                              "below_channels.youTube.genre",
                              selected,
                            )
                          }
                          value={formData.below_channels.youTube.genre}
                        />
                        <div className="text-danger">
                          {errors.below_channels_youTube_genre && (
                            <p>{errors.below_channels_youTube_genre}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="subscribers">
                          Subscribers
                          <span className="text-danger">*</span>:
                        </label>
                        <FormattedInputYouTube
                          type="text"
                          className="form-control"
                          name="below_channels.youTube.subscribers"
                          placeholder="Enter Subscribers"
                          value={Math.trunc(
                            formData?.below_channels.youTube.subscribers,
                          )}
                          onChange={handleInputChange}
                          required
                          disabled
                        />
                        <div className="text-danger">
                          {errors.below_channels_youTube_subscribers && (
                            <p>{errors.below_channels_youTube_subscribers}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label for="avgViews">Average Views :</label>
                        <FormattedInputYouTube
                          type="text"
                          className="form-control"
                          name="below_channels.youTube.average_Views"
                          placeholder="Enter Average Views"
                          value={Math.trunc(
                            formData?.below_channels.youTube.average_Views,
                          )}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="mt-2 mb-3">
                        <h5 className="text-primary">Video Cost</h5>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Dedicated Video Cost:</label>
                          <FormattedInput
                            label="Dedicated Video Cost"
                            name="below_channels.youTube.dedicated_Video_Cost"
                            value={
                              formData.below_channels.youTube
                                .dedicated_Video_Cost
                            }
                            onChange={handleInputChange}
                          />

                          <div className="video_cost_disp p-1 text-white">
                            {" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Integrated Video Cost:</label>
                          <FormattedInput
                            label="Integrated Video Cost"
                            name="below_channels.youTube.integrated_Video_Cost"
                            value={
                              formData.below_channels.youTube
                                .integrated_Video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp p-1 text-white">
                            {" "}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Conceptual Cost:</label>
                          <FormattedInput
                            label="Conceptual Cost"
                            name="below_channels.youTube.conceptual_Cost"
                            value={
                              formData.below_channels.youTube.conceptual_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp p-1 text-white"></div>
                        </div>
                      </div>

                      <div className="col-md-12 border mb-2">
                        <h5 className="py-2 border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(18-24):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audience_Age18to24"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube
                                    .audience_Age18to24
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(25-34):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audience_Age25to34"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube
                                    .audience_Age25to34
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(35-44):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audience_Age35to44"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube
                                    .audience_Age35to44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age (44+):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audience_Age44"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube.audience_Age44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border  mb-2">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label for="fbgenere">
                              Audience Country
                              <span className="text-danger">*</span>:
                            </label>

                            <Select
                              options={countryList}
                              classNamePrefix="select"
                              value={
                                formData?.below_channels?.youTube
                                  ?.audienceCountry
                              }
                              onChange={(selected) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  below_channels: {
                                    ...prev.below_channels,

                                    youTube: {
                                      ...prev.below_channels.youTube,

                                      audienceCountry: selected,

                                      audienceData: [
                                        {
                                          audienceState: "",
                                          audienceCountryName: "",
                                          audienceStatePercentage: "",
                                        },
                                      ],
                                    },
                                  },
                                }));
                              }}
                            />
                          </div>
                          {formData?.below_channels?.youTube
                            ?.audienceCountry && (
                            <div className="row mt-3">
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    handleAddAudienceRow("youTube")
                                  }
                                >
                                  + Add More
                                </button>
                              </div>

                              {formData?.below_channels?.youTube?.audienceData?.map(
                                (item, index) => (
                                  <div className="row mb-3" key={index}>
                                    {/* INDIA */}

                                    {formData?.below_channels?.youTube
                                      ?.audienceCountry?.label === "India" ? (
                                      <>
                                        <div className="col-md-6">
                                          <label>State Name</label>

                                          <Select
                                            options={stateList?.data}
                                            value={item.audienceState}
                                            classNamePrefix="select"
                                            onChange={(selected) =>
                                              handleAudienceChange(
                                                "youTube",
                                                index,
                                                "audienceState",
                                                selected,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>State Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "youTube",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* OTHER */}

                                        <div className="col-md-6">
                                          <label>Country Name</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceCountryName}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "youTube",
                                                index,
                                                "audienceCountryName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>Country Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "youTube",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    )}

                                    {/* REMOVE */}

                                    {index !== 0 && (
                                      <div className="col-md-12 text-end mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveAudienceRow(
                                              "youTube",
                                              index,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Reach Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender (Male) :
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audienceReachGenderMale"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube
                                    .audienceReachGenderMale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender Female:
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.youTube.audienceReachGenderFemale"
                                placeholder="Enter value in %"
                                value={
                                  formData.below_channels.youTube
                                    .audienceReachGenderFemale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "youTube")}
                            />

                            {formData?.below_channels?.youTube?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData?.below_channels?.youTube?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="text-danger">
                        {errors.below_channels_youTube && (
                          <p>{errors.below_channels_youTube}</p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {formData.below_channels.facebook_status && (
                  <div id="facebookInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Facebook</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="facebookUrl">
                          Facebook URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.facebook.facebook_URL"
                          placeholder="Enter Facebook URL"
                          value={
                            formData?.below_channels?.facebook?.facebook_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <p
                          className="validationMessage"
                          style={{ color: "black" }}
                        ></p>
                        <div className="text-danger">
                          {errors.below_channels_facebook_facebook_URL && (
                            <p>{errors.below_channels_facebook_facebook_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="likes">
                          Followers<span className="text-danger">*</span>:
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.facebook.followers"
                          placeholder="Enter Followers"
                          value={formData?.below_channels?.facebook?.followers}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_facebook_followers && (
                            <p>{errors.below_channels_facebook_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="ygenere">Video Cost:</label>
                        <FormattedInput
                          label=" Video Cost"
                          name="below_channels.facebook.video_Cost"
                          placeholder="Enter Video Cost"
                          value={formData?.below_channels?.facebook?.video_Cost}
                          onChange={handleInputChange}
                        />
                        <div className="video_cost_disp text-white"></div>
                        <div className="text-danger">
                          {errors.below_channels_facebook_video_Cost && (
                            <p>{errors.below_channels_facebook_video_Cost}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="fbgenere">
                          Genre<span className="text-danger">*</span>:
                        </label>
                        <Select
                          name="below_channels.facebook.genre"
                          options={genreList?.data?.map((genre) => ({
                            value: genre?.value,
                            label: genre?.label,
                          }))}
                          classNamePrefix="select"
                          onChange={(selected) =>
                            handleSelectChange1(
                              "below_channels.facebook.genre",
                              selected,
                            )
                          }
                          value={formData?.below_channels?.facebook?.genre}
                        />
                      </div>
                      <div className="col-md-12 border mb-2">
                        <h5 className="py-2 border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(18-24):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.facebook.audience_Age18to24"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audience_Age18to24
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(25-34):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.facebook.audience_Age25to34"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audience_Age25to34
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(35-44):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.facebook.audience_Age35to44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audience_Age35to44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age (44+):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.facebook.audience_Age44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audience_Age44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border  mb-2">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label for="fbgenere">
                              Audience Country
                              <span className="text-danger">*</span>:
                            </label>

                            <Select
                              options={countryList}
                              classNamePrefix="select"
                              value={
                                formData?.below_channels?.facebook
                                  ?.audienceCountry
                              }
                              onChange={(selected) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  below_channels: {
                                    ...prev.below_channels,

                                    facebook: {
                                      ...prev.below_channels.facebook,

                                      audienceCountry: selected,

                                      audienceData: [
                                        {
                                          audienceState: "",
                                          audienceCountryName: "",
                                          audienceStatePercentage: "",
                                        },
                                      ],
                                    },
                                  },
                                }));
                              }}
                            />
                          </div>
                          {formData?.below_channels?.facebook
                            ?.audienceCountry && (
                            <div className="row mt-3">
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    handleAddAudienceRow("facebook")
                                  }
                                >
                                  + Add More
                                </button>
                              </div>

                              {formData?.below_channels?.facebook?.audienceData?.map(
                                (item, index) => (
                                  <div className="row mb-3" key={index}>
                                    {/* INDIA */}

                                    {formData?.below_channels?.facebook
                                      ?.audienceCountry?.label === "India" ? (
                                      <>
                                        <div className="col-md-6">
                                          <label>State Name</label>

                                          <Select
                                            options={stateList?.data}
                                            value={item.audienceState}
                                            classNamePrefix="select"
                                            onChange={(selected) =>
                                              handleAudienceChange(
                                                "facebook",
                                                index,
                                                "audienceState",
                                                selected,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>State Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "facebook",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* OTHER */}

                                        <div className="col-md-6">
                                          <label>Country Name</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceCountryName}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "facebook",
                                                index,
                                                "audienceCountryName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>Country Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "facebook",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    )}

                                    {/* REMOVE */}

                                    {index !== 0 && (
                                      <div className="col-md-12 text-end mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveAudienceRow(
                                              "facebook",
                                              index,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Reach Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender (Male) :
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.facebook.audienceReachGenderMale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audienceReachGenderMale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender Female:
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.facebookaudienceReachGenderFemale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.facebook
                                    ?.audienceReachGenderFemale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
<div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "facebook")}
                            />

                            {formData?.below_channels?.facebook?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData?.below_channels?.facebook?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="text-danger">
                        {errors.below_channels_facebook_genre && (
                          <p>{errors.below_channels_facebook_genre}</p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {formData.below_channels.instagram_status && (
                  <div id="instagramInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Instagram</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="instagramUrl">
                          Instagram URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.instagram.instagram_URL"
                          placeholder="Enter Instagram URL"
                          value={
                            formData?.below_channels?.instagram?.instagram_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <p
                          className="validationMessageinsta"
                          style={{ color: "black" }}
                        ></p>
                        <div className="text-danger">
                          {errors.below_channels_instagram_instagram_URL && (
                            <p>
                              {errors.below_channels_instagram_instagram_URL}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="followersInstagram">
                          Followers<span className="text-danger">*</span>:
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.instagram.followers"
                          placeholder="Enter Followers"
                          value={formData?.below_channels?.instagram?.followers}
                          onChange={handleInputChange}
                          required
                        />

                        <div className="text-danger">
                          {errors.below_channels_instagram_followers && (
                            <p>{errors.below_channels_instagram_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.instagram.video_Cost"
                            placeholder="Enter Video Cost"
                            value={
                              formData?.below_channels?.instagram?.video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp text-white"></div>
                          <div className="text-danger">
                            {errors.below_channels_instagram_video_Cost && (
                              <p>
                                {errors.below_channels_instagram_video_Cost}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.instagram.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.instagram.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.instagram?.genre}
                          />
                          </div>
                          </div>
                          <div className="col-md-12 border mb-2">
                            <h5 className="py-2 border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(18-24):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.instagram.audience_Age18to24"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audience_Age18to24
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(25-34):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.instagram.audience_Age25to34"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audience_Age25to34
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(35-44):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.instagram.audience_Age35to44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audience_Age35to44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age (44+):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.instagram.audience_Age44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audience_Age44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 border  mb-2">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label for="fbgenere">
                                  Audience Country
                                  <span className="text-danger">*</span>:
                                </label>

                                <Select
                                  options={countryList}
                                  classNamePrefix="select"
                                  value={
                                    formData?.below_channels?.instagram
                                      ?.audienceCountry
                                  }
                                  onChange={(selected) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      below_channels: {
                                        ...prev.below_channels,

                                        instagram: {
                                          ...prev.below_channels.instagram,

                                          audienceCountry: selected,

                                          audienceData: [
                                            {
                                              audienceState: "",
                                              audienceCountryName: "",
                                              audienceStatePercentage: "",
                                            },
                                          ],
                                        },
                                      },
                                    }));
                                  }}
                                />
                              </div>
                              {formData?.below_channels?.instagram
                                ?.audienceCountry && (
                                <div className="row mt-3">
                                  <div className="d-flex justify-content-end align-items-center mb-3">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleAddAudienceRow("instagram")
                                      }
                                    >
                                      + Add More
                                    </button>
                                  </div>

                                  {formData?.below_channels?.instagram?.audienceData?.map(
                                    (item, index) => (
                                      <div className="row mb-3" key={index}>
                                        {/* INDIA */}

                                        {formData?.below_channels?.instagram
                                          ?.audienceCountry?.label ===
                                        "India" ? (
                                          <>
                                            <div className="col-md-6">
                                              <label>State Name</label>

                                              <Select
                                                options={stateList?.data}
                                                value={item.audienceState}
                                                classNamePrefix="select"
                                                onChange={(selected) =>
                                                  handleAudienceChange(
                                                    "instagram",
                                                    index,
                                                    "audienceState",
                                                    selected,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>State Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "instagram",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            {/* OTHER */}

                                            <div className="col-md-6">
                                              <label>Country Name</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.audienceCountryName}
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "instagram",
                                                    index,
                                                    "audienceCountryName",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>Country Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "instagram",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        )}

                                        {/* REMOVE */}

                                        {index !== 0 && (
                                          <div className="col-md-12 text-end mt-2">
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={() =>
                                                handleRemoveAudienceRow(
                                                  "instagram",
                                                  index,
                                                )
                                              }
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12 border">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Reach Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender (Male) :
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.instagram.audienceReachGenderMale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audienceReachGenderMale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender Female:
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.instagram.audienceReachGenderFemale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.instagram
                                        ?.audienceReachGenderFemale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
<div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "instagram")}
                            />

                            {formData?.below_channels?.instagram?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData?.below_channels?.instagram?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                          <div className="text-danger">
                            {errors.below_channels_instagram_genre && (
                              <p>{errors.below_channels_instagram_genre}</p>
                            )}
                          </div>
                        </div>
                      </div>
                )}
                {formData.below_channels.twitter_X_status && (
                  <div id="twitterInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Twitter (X)</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="instagramUrl">
                          Twitter URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.twitter_X.twitter_URL"
                          placeholder="Enter Instagram URL"
                          value={
                            formData?.below_channels?.twitter_X?.twitter_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <p
                          className="validationMessageinsta"
                          style={{ color: "black" }}
                        ></p>
                        <div className="text-danger">
                          {errors.below_channels_twitter_X_twitter_URL && (
                            <p>{errors.below_channels_twitter_X_twitter_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="followersInstagram">
                          Followers<span className="text-danger">*</span>:
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.twitter_X.followers"
                          placeholder="Enter Followers"
                          value={formData?.below_channels?.twitter_X?.followers}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_twitter_X_followers && (
                            <p>{errors.below_channels_twitter_X_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.twitter_X.video_Cost"
                            placeholder="Enter Video Cost"
                            value={
                              formData?.below_channels?.twitter_X?.video_Cost
                            }
                            onChange={handleInputChange}
                          />

                          <div className="video_cost_disp text-white"></div>

                          <div className="text-danger">
                            {errors.below_channels_twitter_X_video_Cost && (
                              <p>
                                {errors.below_channels_twitter_X_video_Cost}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.twitter_X.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.twitter_X.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.twitter_X?.genre}
                          />
                          <div className="text-danger">
                            {errors.below_channels_twitter_X_genre && (
                              <p>{errors.below_channels_twitter_X_genre}</p>
                            )}
                          </div>
</div>
</div>
                          <div className="col-md-12 border mb-2">
                            <h5 className="py-2 border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(18-24):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.twitter_X.audience_Age18to24"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audience_Age18to24
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(25-34):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.twitter_X.audience_Age25to34"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audience_Age25to34
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(35-44):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.twitter_X.audience_Age35to44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audience_Age35to44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age (44+):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.twitter_X.audience_Age44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audience_Age44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 border  mb-2">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label for="fbgenere">
                                  Audience Country
                                  <span className="text-danger">*</span>:
                                </label>

                                <Select
                                  options={countryList}
                                  classNamePrefix="select"
                                  value={
                                    formData?.below_channels?.twitter_X
                                      ?.audienceCountry
                                  }
                                  onChange={(selected) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      below_channels: {
                                        ...prev.below_channels,

                                        twitter_X: {
                                          ...prev.below_channels.twitter_X,

                                          audienceCountry: selected,

                                          audienceData: [
                                            {
                                              audienceState: "",
                                              audienceCountryName: "",
                                              audienceStatePercentage: "",
                                            },
                                          ],
                                        },
                                      },
                                    }));
                                  }}
                                />
                              </div>
                              {formData?.below_channels?.twitter_X
                                ?.audienceCountry && (
                                <div className="row mt-3">
                                  <div className="d-flex justify-content-end align-items-center mb-3">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleAddAudienceRow("twitter_X")
                                      }
                                    >
                                      + Add More
                                    </button>
                                  </div>

                                  {formData?.below_channels?.twitter_X?.audienceData?.map(
                                    (item, index) => (
                                      <div className="row mb-3" key={index}>
                                        {/* INDIA */}

                                        {formData?.below_channels?.twitter_X
                                          ?.audienceCountry?.label ===
                                        "India" ? (
                                          <>
                                            <div className="col-md-6">
                                              <label>State Name</label>

                                              <Select
                                                options={stateList?.data}
                                                value={item.audienceState}
                                                classNamePrefix="select"
                                                onChange={(selected) =>
                                                  handleAudienceChange(
                                                    "twitter_X",
                                                    index,
                                                    "audienceState",
                                                    selected,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>State Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "twitter_X",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            {/* OTHER */}

                                            <div className="col-md-6">
                                              <label>Country Name</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.audienceCountryName}
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "twitter_X",
                                                    index,
                                                    "audienceCountryName",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>Country Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "twitter_X",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        )}

                                        {/* REMOVE */}

                                        {index !== 0 && (
                                          <div className="col-md-12 text-end mt-2">
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={() =>
                                                handleRemoveAudienceRow(
                                                  "twitter_X",
                                                  index,
                                                )
                                              }
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12 border">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Reach Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender (Male) :
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.twitter_X.audienceReachGenderMale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audienceReachGenderMale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender Female:
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.twitter_X.audienceReachGenderFemale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.twitter_X
                                        ?.audienceReachGenderFemale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "twitter_X")}
                            />

                            {formData.below_channels.twitter_X?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData.below_channels.twitter_X?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                          </div>
                          </div>
                    </div>
                  </div>
                )}
                {formData.below_channels.linkedIn_status && (
                  <div id="linkedinInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Linkedin</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="linkedinUrl">
                          LinkedIn URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.linkedIn.linkedIn_URL"
                          placeholder="Enter Instagram URL"
                          value={
                            formData?.below_channels?.linkedIn?.linkedIn_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <p
                          className="validationMessagelink"
                          style={{ color: "black" }}
                        ></p>
                        <div className="text-danger">
                          {errors.below_channels_linkedIn_linkedIn_URL && (
                            <p>{errors.below_channels_linkedIn_linkedIn_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="connections">
                          Connections
                          <span className="text-danger">*</span>:
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.linkedIn.connections"
                          placeholder="Enter Connections"
                          value={
                            formData?.below_channels?.linkedIn?.connections
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_linkedIn_connections && (
                            <p>{errors.below_channels_linkedIn_connections}</p>
                          )}
                        </div>
                      </div>
                      {/* <div className="row"> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.linkedIn.video_Cost"
                            placeholder="Enter Connections"
                            value={
                              formData?.below_channels?.linkedIn?.video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp text-white"></div>
                          <div className="text-danger">
                            {errors.below_channels_linkedIn_video_Cost && (
                              <p>{errors.below_channels_linkedIn_video_Cost}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.linkedIn.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.linkedIn.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.linkedIn?.genre}
                          />
                          <div className="text-danger">
                            {errors.below_channels_linkedIn_genre && (
                              <p>{errors.below_channels_linkedIn_genre}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 border mb-2">
                        <h5 className="py-2 border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(18-24):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.linkedIn.audience_Age18to24"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audience_Age18to24
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(25-34):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.linkedIn.audience_Age25to34"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audience_Age25to34
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(35-44):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.linkedIn.audience_Age35to44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audience_Age35to44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age (44+):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.linkedIn.audience_Age44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audience_Age44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border  mb-2">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label for="fbgenere">
                              Audience Country
                              <span className="text-danger">*</span>:
                            </label>

                            <Select
                              options={countryList}
                              classNamePrefix="select"
                              value={
                                formData?.below_channels?.linkedIn
                                  ?.audienceCountry
                              }
                              onChange={(selected) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  below_channels: {
                                    ...prev.below_channels,

                                    linkedIn: {
                                      ...prev.below_channels.linkedIn,

                                      audienceCountry: selected,

                                      audienceData: [
                                        {
                                          audienceState: "",
                                          audienceCountryName: "",
                                          audienceStatePercentage: "",
                                        },
                                      ],
                                    },
                                  },
                                }));
                              }}
                            />
                          </div>
                          {formData?.below_channels?.linkedIn
                            ?.audienceCountry && (
                            <div className="row mt-3">
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    handleAddAudienceRow("linkedIn")
                                  }
                                >
                                  + Add More
                                </button>
                              </div>

                              {formData?.below_channels?.linkedIn?.audienceData?.map(
                                (item, index) => (
                                  <div className="row mb-3" key={index}>
                                    {/* INDIA */}

                                    {formData?.below_channels?.linkedIn
                                      ?.audienceCountry?.label === "India" ? (
                                      <>
                                        <div className="col-md-6">
                                          <label>State Name</label>

                                          <Select
                                            options={stateList?.data}
                                            value={item.audienceState}
                                            classNamePrefix="select"
                                            onChange={(selected) =>
                                              handleAudienceChange(
                                                "linkedIn",
                                                index,
                                                "audienceState",
                                                selected,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>State Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "linkedIn",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* OTHER */}

                                        <div className="col-md-6">
                                          <label>Country Name</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceCountryName}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "linkedIn",
                                                index,
                                                "audienceCountryName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>Country Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "linkedIn",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    )}

                                    {/* REMOVE */}

                                    {index !== 0 && (
                                      <div className="col-md-12 text-end mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveAudienceRow(
                                              "linkedIn",
                                              index,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Reach Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender (Male) :
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.linkedIn.audienceReachGenderMale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audienceReachGenderMale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender Female:
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.linkedIn.audienceReachGenderFemale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.linkedIn
                                    ?.audienceReachGenderFemale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "linkedIn")}
                            />

                            {formData.below_channels.linkedIn?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData.below_channels.linkedIn?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                          </div>
                          </div>
                      {/* </div> */}
                    </div>
                  </div>
                )}
                {formData.below_channels.whatsapp_status && (
                  <div id="whatsappInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Whatsapp</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="whatsappUrl">
                          Whatsapp Channel URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.whatsapp.whatsapp_Channel_URL"
                          placeholder="Enter Whatsapp Channel URL"
                          value={
                            formData?.below_channels?.whatsapp
                              ?.whatsapp_Channel_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_whatsapp_whatsapp_Channel_URL && (
                            <p>
                              {
                                errors.below_channels_whatsapp_whatsapp_Channel_URL
                              }
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="whatsappUrl">
                          Followers<span className="text-danger">*</span>
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.whatsapp.followers"
                          placeholder="Enter Whatsapp Channel URL"
                          value={formData?.below_channels?.whatsapp?.followers}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_whatsapp_followers && (
                            <p>{errors.below_channels_whatsapp_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.whatsapp.video_Cost"
                            placeholder="Enter Whatsapp Video Cost"
                            value={
                              formData?.below_channels?.whatsapp?.video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp text-white"></div>
                          <div className="text-danger">
                            {errors.below_channels_whatsapp_video_Cost && (
                              <p>{errors.below_channels_whatsapp_video_Cost}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.whatsapp.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.whatsapp.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.whatsapp?.genre}
                          />
                          <div className="text-danger">
                            {errors.below_channels_whatsapp_genre && (
                              <p>{errors.below_channels_whatsapp_genre}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 border mb-2">
                        <h5 className="py-2 border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(18-24):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.whatsapp.audience_Age18to24"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audience_Age18to24
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(25-34):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.whatsapp.audience_Age25to34"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audience_Age25to34
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(35-44):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.whatsapp.audience_Age35to44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audience_Age35to44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age (44+):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.whatsapp.audience_Age44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audience_Age44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border  mb-2">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label for="fbgenere">
                              Audience Country
                              <span className="text-danger">*</span>:
                            </label>

                            <Select
                              options={countryList}
                              classNamePrefix="select"
                              value={
                                formData?.below_channels?.whatsapp
                                  ?.audienceCountry
                              }
                              onChange={(selected) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  below_channels: {
                                    ...prev.below_channels,

                                    whatsapp: {
                                      ...prev.below_channels.whatsapp,

                                      audienceCountry: selected,

                                      audienceData: [
                                        {
                                          audienceState: "",
                                          audienceCountryName: "",
                                          audienceStatePercentage: "",
                                        },
                                      ],
                                    },
                                  },
                                }));
                              }}
                            />
                          </div>
                          {formData?.below_channels?.whatsapp
                            ?.audienceCountry && (
                            <div className="row mt-3">
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    handleAddAudienceRow("whatsapp")
                                  }
                                >
                                  + Add More
                                </button>
                              </div>

                              {formData?.below_channels?.whatsapp?.audienceData?.map(
                                (item, index) => (
                                  <div className="row mb-3" key={index}>
                                    {/* INDIA */}

                                    {formData?.below_channels?.whatsapp
                                      ?.audienceCountry?.label === "India" ? (
                                      <>
                                        <div className="col-md-6">
                                          <label>State Name</label>

                                          <Select
                                            options={stateList?.data}
                                            value={item.audienceState}
                                            classNamePrefix="select"
                                            onChange={(selected) =>
                                              handleAudienceChange(
                                                "whatsapp",
                                                index,
                                                "audienceState",
                                                selected,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>State Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "whatsapp",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* OTHER */}

                                        <div className="col-md-6">
                                          <label>Country Name</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceCountryName}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "whatsapp",
                                                index,
                                                "audienceCountryName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>Country Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "whatsapp",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    )}

                                    {/* REMOVE */}

                                    {index !== 0 && (
                                      <div className="col-md-12 text-end mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveAudienceRow(
                                              "whatsapp",
                                              index,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Reach Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender (Male) :
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.whatsapp.audienceReachGenderMale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audienceReachGenderMale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender Female:
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.whatsapp.audienceReachGenderFemale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.whatsapp
                                    ?.audienceReachGenderFemale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "whatsapp")}
                            />

                            {formData.below_channels.whatsapp?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData.below_channels.whatsapp?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                          </div>
                          </div>
                    </div>
                  </div>
                )}
                {formData.below_channels.telegram_status && (
                  <div id="telegramInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Telegram</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="telegramUrl">
                          Telegram URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.telegram.telegram_URL"
                          placeholder="Enter telegram Video Cost"
                          value={
                            formData?.below_channels?.telegram?.telegram_URL
                          }
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_telegram_telegram_URL && (
                            <p>{errors.below_channels_telegram_telegram_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="whatsappUrl">
                          Followers<span className="text-danger">*</span>
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.telegram.followers"
                          placeholder="Enter telegram Followers"
                          value={formData?.below_channels?.telegram?.followers}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_telegram_followers && (
                            <p>{errors.below_channels_telegram_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.telegram.video_Cost"
                            placeholder="Enter telegram Video Cost"
                            value={
                              formData?.below_channels?.telegram?.video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp text-white"></div>
                          <div className="text-danger">
                            {errors.below_channels_telegram_video_Cost && (
                              <p>{errors.below_channels_telegram_video_Cost}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.telegram.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.telegram.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.telegram?.genre}
                          />
                          <div className="text-danger">
                            {errors.below_channels_telegram_genre && (
                              <p>{errors.below_channels_telegram_genre}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 border mb-2">
                        <h5 className="py-2 border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(18-24):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.telegram.audience_Age18to24"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audience_Age18to24
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(25-34):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.telegram.audience_Age25to34"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audience_Age25to34
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age(35-44):</label>

                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.telegram.audience_Age35to44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audience_Age35to44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">Audience Age (44+):</label>
                              <input
                                type="text"
                                className="form-control"
                                name="below_channels.telegram.audience_Age44"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audience_Age44
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border  mb-2">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Age Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label for="fbgenere">
                              Audience Country
                              <span className="text-danger">*</span>:
                            </label>

                            <Select
                              options={countryList}
                              classNamePrefix="select"
                              value={
                                formData?.below_channels?.telegram
                                  ?.audienceCountry
                              }
                              onChange={(selected) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  below_channels: {
                                    ...prev.below_channels,

                                    telegram: {
                                      ...prev.below_channels.telegram,

                                      audienceCountry: selected,

                                      audienceData: [
                                        {
                                          audienceState: "",
                                          audienceCountryName: "",
                                          audienceStatePercentage: "",
                                        },
                                      ],
                                    },
                                  },
                                }));
                              }}
                            />
                          </div>
                          {formData?.below_channels?.telegram
                            ?.audienceCountry && (
                            <div className="row mt-3">
                              <div className="d-flex justify-content-end align-items-center mb-3">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    handleAddAudienceRow("telegram")
                                  }
                                >
                                  + Add More
                                </button>
                              </div>

                              {formData?.below_channels?.telegram?.audienceData?.map(
                                (item, index) => (
                                  <div className="row mb-3" key={index}>
                                    {/* INDIA */}

                                    {formData?.below_channels?.telegram
                                      ?.audienceCountry?.label === "India" ? (
                                      <>
                                        <div className="col-md-6">
                                          <label>State Name</label>

                                          <Select
                                            options={stateList?.data}
                                            value={item.audienceState}
                                            classNamePrefix="select"
                                            onChange={(selected) =>
                                              handleAudienceChange(
                                                "telegram",
                                                index,
                                                "audienceState",
                                                selected,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>State Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "telegram",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* OTHER */}

                                        <div className="col-md-6">
                                          <label>Country Name</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceCountryName}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "telegram",
                                                index,
                                                "audienceCountryName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <label>Country Percentage</label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={item.audienceStatePercentage}
                                            onChange={(e) =>
                                              handleAudienceChange(
                                                "telegram",
                                                index,
                                                "audienceStatePercentage",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                    )}

                                    {/* REMOVE */}

                                    {index !== 0 && (
                                      <div className="col-md-12 text-end mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveAudienceRow(
                                              "telegram",
                                              index,
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Audience Reach Details
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender (Male) :
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.telegram.audienceReachGenderMale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audienceReachGenderMale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label for="ygenere">
                                Audience Reach Gender Female:
                              </label>

                              <input
                                type="text"
                                className="form-control"
                                name="formData.below_channels.telegram.audienceReachGenderFemale"
                                placeholder="Enter value in %"
                                value={
                                  formData?.below_channels?.telegram
                                    ?.audienceReachGenderFemale
                                }
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "telegram")}
                            />

                            {formData.below_channels.telegram?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData.below_channels.telegram?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                          </div>
                          </div>
                    </div>
                  </div>
                )}
                {formData.below_channels.threads_status && (
                  <div id="threadsInfo">
                    <div className="row">
                      <div className="mt-2">
                        <h5 className="text-primary">Threads</h5>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="threadsUrl">
                          Threads URL
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="below_channels.threads.threads_URL"
                          placeholder="Enter telegram Threads URL"
                          value={formData?.below_channels?.threads?.threads_URL}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_threads_threads_URL && (
                            <p>{errors.below_channels_threads_threads_URL}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label for="whatsappUrl">
                          Followers<span className="text-danger">*</span>
                        </label>
                        <FormattedInput
                          type="text"
                          className="form-control"
                          name="below_channels.threads.followers"
                          placeholder="Enter telegram Followers"
                          value={formData?.below_channels?.threads?.followers}
                          onChange={handleInputChange}
                          required
                        />
                        <div className="text-danger">
                          {errors.below_channels_threads_followers && (
                            <p>{errors.below_channels_threads_followers}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="ygenere">Video Cost:</label>
                          <FormattedInput
                            label="Video Cost"
                            name="below_channels.threads.video_Cost"
                            placeholder="Enter telegram Video Cost"
                            value={
                              formData?.below_channels?.threads?.video_Cost
                            }
                            onChange={handleInputChange}
                          />
                          <div className="video_cost_disp text-white"></div>
                          <div className="text-danger">
                            {errors.below_channels_threads_video_Cost && (
                              <p>{errors.below_channels_threads_video_Cost}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="fbgenere">
                            Genre<span className="text-danger">*</span>:
                          </label>
                          <Select
                            name="below_channels.threads.genre"
                            options={genreList?.data?.map((genre) => ({
                              value: genre?.value,
                              label: genre?.label,
                            }))}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange1(
                                "below_channels.threads.genre",
                                selected,
                              )
                            }
                            value={formData?.below_channels?.threads?.genre}
                          />
                          <div className="text-danger">
                            {errors.below_channels_threads_genre && (
                              <p>{errors.below_channels_threads_genre}</p>
                            )}
                          </div>
                          </div>
                          </div>
                          <div className="col-md-12 border mb-2">
                            <h5 className="py-2 border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(18-24):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.threads.audience_Age18to24"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audience_Age18to24
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(25-34):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.threads.audience_Age25to34"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audience_Age25to34
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age(35-44):
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.threads.audience_Age35to44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audience_Age35to44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Age (44+):
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="below_channels.threads.audience_Age44"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audience_Age44
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 border  mb-2">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Age Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label for="fbgenere">
                                  Audience Country
                                  <span className="text-danger">*</span>:
                                </label>

                                <Select
                                  options={countryList}
                                  classNamePrefix="select"
                                  value={
                                    formData?.below_channels?.threads
                                      ?.audienceCountry
                                  }
                                  onChange={(selected) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      below_channels: {
                                        ...prev.below_channels,

                                        threads: {
                                          ...prev.below_channels.threads,

                                          audienceCountry: selected,

                                          audienceData: [
                                            {
                                              audienceState: "",
                                              audienceCountryName: "",
                                              audienceStatePercentage: "",
                                            },
                                          ],
                                        },
                                      },
                                    }));
                                  }}
                                />
                              </div>
                              {formData?.below_channels?.threads
                                ?.audienceCountry && (
                                <div className="row mt-3">
                                  <div className="d-flex justify-content-end align-items-center mb-3">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleAddAudienceRow("threads")
                                      }
                                    >
                                      + Add More
                                    </button>
                                  </div>

                                  {formData?.below_channels?.threads?.audienceData?.map(
                                    (item, index) => (
                                      <div className="row mb-3" key={index}>
                                        {/* INDIA */}

                                        {formData?.below_channels?.threads
                                          ?.audienceCountry?.label ===
                                        "India" ? (
                                          <>
                                            <div className="col-md-6">
                                              <label>State Name</label>

                                              <Select
                                                options={stateList?.data}
                                                value={item.audienceState}
                                                classNamePrefix="select"
                                                onChange={(selected) =>
                                                  handleAudienceChange(
                                                    "threads",
                                                    index,
                                                    "audienceState",
                                                    selected,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>State Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "threads",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            {/* OTHER */}

                                            <div className="col-md-6">
                                              <label>Country Name</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={item.audienceCountryName}
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "threads",
                                                    index,
                                                    "audienceCountryName",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label>Country Percentage</label>

                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  item.audienceStatePercentage
                                                }
                                                onChange={(e) =>
                                                  handleAudienceChange(
                                                    "threads",
                                                    index,
                                                    "audienceStatePercentage",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        )}

                                        {/* REMOVE */}

                                        {index !== 0 && (
                                          <div className="col-md-12 text-end mt-2">
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={() =>
                                                handleRemoveAudienceRow(
                                                  "threads",
                                                  index,
                                                )
                                              }
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12 border">
                            <h5 className="py-2 text-primary  border-bottom">
                              Audience Reach Details
                            </h5>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender (Male) :
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.threads.audienceReachGenderMale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audienceReachGenderMale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label for="ygenere">
                                    Audience Reach Gender Female:
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="formData.below_channels.threads.audienceReachGenderFemale"
                                    placeholder="Enter value in %"
                                    value={
                                      formData?.below_channels?.threads
                                        ?.audienceReachGenderFemale
                                    }
                                    onChange={handleInputChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                      <div className="col-md-12 border">
                        <h5 className="py-2 text-primary  border-bottom">
                          Upload Image
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "threads")}
                            />

                            {formData.below_channels.threads?.imageFile && (
                              <img
                                src={URL.createObjectURL(
                                  formData.below_channels.threads?.imageFile,
                                )}
                                alt="preview"
                                width="100"
                                className="mt-2 rounded"
                              />
                            )}
                          </div>
                          </div>
                          </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="mb-4">
                <hr />
                <p className="mb-0 fs-12 text-muted fst-italic">
                  By registering you agree to the Influencer Act{" "}
                  <a
                    href="#"
                    className="text-primary text-decoration-underline fst-normal fw-medium"
                  >
                    Terms of Use
                  </a>
                </p>
              </div>
              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-success w-100"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfluencerRegister;
